import React, { useState } from "react";
import "../style/ShopifyDash.css";
import { FaCode } from "react-icons/fa";

const IconButton = ({ text, icon: Icon }) => (
  <button className="flex items-center gap-2 bg-blue-100 text-blue-500 px-4 py-2 rounded-full hover:bg-blue-200 transition">
    {Icon && <Icon className="text-blue-500" />}
    <span className="text-xs">{text}</span>
  </button>
);

const PostCard = ({
  name = "No Name", // Ensures a default fallback value
  content = "No Content",
  description = "No Description", // Added description with a default value
  image_path = null,
  video_path = null,
  status = "Unknown",
  user_name = "Unknown User",
  profile_picture = null,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="w-full max-w-sm rounded-xl bg-white shadow-md p-4 transition-transform hover:scale-105"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Media Section */}
      <div className="flex flex-col gap-3">
        {isHovered && video_path ? (
          <video autoPlay loop muted className="w-full h-48 object-cover rounded-xl">
            <source src={video_path} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : image_path ? (
          <img
            src={image_path}
            alt={name}
            className="w-full h-48 rounded-xl object-cover"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/fallback-image.jpg"; // Fallback for broken image
            }}
          />
        ) : (
          <div className="h-48 bg-gray-200 rounded-xl flex items-center justify-center">
            <span className="text-sm text-gray-500">No Media Available</span>
          </div>
        )}

        {/* Post Details */}
        <div>
          <IconButton text="Shopify" icon={FaCode} />
          <h3 className="text-m my-1 font-bold text-gray-800 truncate">
            {name || "No Name"} {/* Ensure name is rendered properly */}
          </h3>
          <p className="text-xs text-gray-500 truncate">{content}</p>
          <p className="text-xs text-gray-500 truncate">
            {description} {/* Display description */}
          </p>
          <p className="text-xs text-gray-500">Status: {status}</p>
        </div>
      </div>

      {/* Divider */}
      <hr className="my-4 border-gray-200" />

      {/* User Info Section */}
      <div className="flex items-center">
        {profile_picture ? (
          <img
            src={profile_picture}
            alt={user_name}
            className="w-8 h-8 rounded-full object-cover mr-3"
          />
        ) : (
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 text-gray-700 font-bold mr-3">
            {user_name ? user_name.charAt(0).toUpperCase() : "?"}
          </div>
        )}
        <span className="text-sm font-semibold text-gray-800">
          {user_name || "Unknown User"}
        </span>
      </div>
    </div>
  );
};

export default PostCard;
